import { Localisation } from "./Localisation";

/**
 * This class parses a string which is expected to be a multi-lingual field, in json format, with the following structure
 * {
 *  "en-GB": "Elevator",
 *  "es-ES": "Ascensor",
 *  "de-DE": "Aufzug",
 *  "ja-JP": "...."
 *  }
 *  the parsed keys are then matched to the list of supported languages taken from appContext().language
 *  (this is to support adding/removing languages in the future)
 *  if parsing fails, a default value is returned (with all the keys taken from appContext().language and empty values)
 */
export class LanguageValuesHelper
{
    private localisation: Localisation;

    constructor(localisation: Localisation)
    {
        this.localisation = localisation;
    }

    private getLanguages()
    {
        const { languages } = this.localisation.languages;
        return languages.filter(lang => lang.code !== this.localisation.terms)
    }

    public default(): ILanguageValues
    {
        const values: ILanguageValues = {};

        for (const language of this.getLanguages())
        {
            values[language.code] = '';
        }

        return values;
    }

    public fromString(value: string): ILanguageValues
    {
        let parsed: Partial<ILanguageValues> = {};
        try
        {
            parsed = JSON.parse(value || '{}') as ILanguageValues ?? {};
        }
        catch (error)
        {
            console.error(error);
        }

        const values: ILanguageValues = {};

        for (const language of this.getLanguages())
        {
            values[language.code] = parsed[language.code] ?? '';
        }

        return values;

    }

    public toString(inputValues: ILanguageValues): string
    {
        const values: ILanguageValues = {}

        for (const language of this.getLanguages())
        {
            values[language.code] = inputValues[language.code] ?? ''
        }
        return JSON.stringify(values);
    }

    public getValue(values: ILanguageValues): string
    {
        return values[this.localisation.languages.current] || values[this.localisation.languages.defaultLanguage];
    }
}

export interface ILanguageValues
{
    [key: string]: string;
}
